import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackEvent } from '../../../client/analytics';

import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

import { DEFAULT_ENVELOPE_BLOCK, TRIGGER_LOCATIONS, TRIGGER_TYPE } from '../../constants/ClickstreamConstants';

const EVENT_IDS = {
  PROOF_OF_INSURANCE_SEND_REQUEST: '7745',
  PROOF_OF_INSURANCE_REQUEST_CLICK: '7746',
} as const;

const PROOF_OF_INSURANCE_CS_TRIGGER_OBJECTS = {
  TENANT_CARD: TRIGGER_LOCATIONS.TENANT_CARD,
  RECOMMENDED_ACTIONS: TRIGGER_LOCATIONS.RECOMMENDED_ACTIONS,
};

// https://dataportal.zillowgroup.net/event-registry/7745
const ProofOfInsuranceSendRequest = ({
  triggerLocation = PROOF_OF_INSURANCE_CS_TRIGGER_OBJECTS.TENANT_CARD,
  currentProperty,
  user,
}: {
  triggerLocation: (typeof PROOF_OF_INSURANCE_CS_TRIGGER_OBJECTS)[keyof typeof PROOF_OF_INSURANCE_CS_TRIGGER_OBJECTS];
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_type_id: EVENT_IDS.PROOF_OF_INSURANCE_SEND_REQUEST,
      ...DEFAULT_ENVELOPE_BLOCK,
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.INTERACTION,
      trigger_location_nm: TRIGGER_LOCATIONS.PROPERTY_OVERVIEW,
      trigger_source_nm: 'send_request',
      trigger_object_nm: triggerLocation,
    },
    semantic: {
      semantic_event_nm: 'send_request_poi',
      topic_tag_txt: [],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/7746
const ProofOfInsuranceRequestClick = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_type_id: EVENT_IDS.PROOF_OF_INSURANCE_REQUEST_CLICK,
      ...DEFAULT_ENVELOPE_BLOCK,
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.INTERACTION,
      trigger_location_nm: TRIGGER_LOCATIONS.PROPERTY_OVERVIEW,
      trigger_source_nm: 'request_proof_of_renters_insurance',
      trigger_object_nm: PROOF_OF_INSURANCE_CS_TRIGGER_OBJECTS.TENANT_CARD,
    },
    semantic: {
      semantic_event_nm: 'request_poi',
      topic_tag_txt: ['renters_insurance'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

const ProofOfInsuranceCSEvents = {
  ProofOfInsuranceRequestClick,
  ProofOfInsuranceSendRequest,
};

// Clickstream visualizer data-eventid attributes
ProofOfInsuranceRequestClick.data_event_id = EVENT_IDS.PROOF_OF_INSURANCE_REQUEST_CLICK;
ProofOfInsuranceSendRequest.data_event_id = EVENT_IDS.PROOF_OF_INSURANCE_SEND_REQUEST;

export { PROOF_OF_INSURANCE_CS_TRIGGER_OBJECTS };

export default ProofOfInsuranceCSEvents;
